import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpToastComponent from './adpToast.component';

let adpToastModule = angular.module('adpToast', [
  uiRouter
])

.component('adpToast', adpToastComponent)

.name;

export default adpToastModule;



// WEBPACK FOOTER //
// ./src/app/components/adpToast/adpToast.js